import { Migration, runMigrations } from "./migration-runner";
import { migration001 } from "./001_create_tables";

export const migrations: Migration[] = [
  {
    version: "001",
    sql: migration001,
  },
];

export { runMigrations };
